export default "__VITE_ASSET__9UXmqI$y__"